import styled from '@emotion/styled';
import { sdsColor, sdsPrimitiveColor, sdsRadius } from '@staging-design-system';
import { rem } from '@utils';

const Items = styled.div<{ $rowCount: number }>(
  ({ $rowCount }) => `
  column-gap: ${rem(16)};
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${rem(200)}, 1fr));
  grid-template-rows: repeat(${$rowCount}, auto);
  margin: 0;
  row-gap: ${rem(8)};
  width: 100%;
`
);

const Item = styled.article<{ $rowCount: number }>(
  ({ $rowCount }) => `
  background: ${sdsColor.background.defaultDefault};
  border: ${rem(1)} solid ${sdsColor.border.defaultDefault};
  border-radius: ${sdsRadius.medium};
  display: grid;
  grid-row: span ${$rowCount};
  grid-template-rows: subgrid;
  padding: ${rem(16)};
  transition: border-color 200ms ease;
  cursor: pointer;

  && > :not(:first-child) {
    margin: 0;
  }

  && > * {
    transition: opacity 200ms ease;
  }

  &:hover {
    border-color: ${sdsColor.border.brandDefault};
  }

  &:hover:not(.active) > * {
    opacity: 0.5;
  }

  &.active {
    border-color: ${sdsColor.border.brandDefault};
  }
`
);

const Title = styled.div`
  color: ${sdsColor.text.defaultDefault};
  font-size: ${rem(16)};
  font-weight: 600;
  line-height: ${rem(24)};
`;

const Body = styled.div`
  align-self: start;
  color: ${sdsColor.text.defaultSecondary};
  font-size: ${rem(12)};
  font-weight: 400;
  line-height: ${rem(16)};
`;

const Value = styled.div`
  color: ${sdsPrimitiveColor.violet['500']};
  font-size: ${rem(24)};
  font-weight: 700;
  line-height: ${rem(30)};
`;

const Description = styled.div`
  color: ${sdsColor.text.defaultDefault};
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(16)};
`;

export default {
  Items,
  Item,
  Title,
  Body,
  Value,
  Description
};
